
// import React, { useState, useMemo, useEffect } from "react";
// import { useLocation } from "react-router-dom";
// import { Button, message } from "antd";
// import Page from "../../components/Page/Page";
// import FilteredTable from "../../components/table/filteredTable";
// import BorderBox from "../../components/BorderBox";
// import generateReceipt from "../../util/pdfExport/pdfRecipt";
// import Classes from "./index.module.css";
// import formatPrice from "../../util/FormatPrice/FormatPrice";
// import { split } from "lodash";
// import { GetDetailInvoice, GetHeadInvoice } from "../../API/reciept";
// import { element } from "prop-types";

// export default function Receipt() {
//   const location = useLocation();

//   // Parse the query string
//   const queryParams = new URLSearchParams(location.search);
//   const [gdata, setgData]= useState({serial:queryParams.get('id').slice(0, 6 ),factor: queryParams.get('id').slice(6, queryParams.get('id').length ) })
//   const [data, setData] = useState({invoiceData:[], HeadData: {}});
//   const [lading, setLoading] = useState(false);
  
 
//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         // Fetch Head Invoice
//         const headResponse = await GetHeadInvoice(queryParams.get('id'));
//         if (!headResponse.success) {
//           message.info(headResponse.message, 3000);
//           return; // Exit early if HeadInvoice fails
//         }
        
//         const headData = headResponse.data[0];

//         // Fetch Detail Invoice
//         const detailResponse = await GetDetailInvoice(queryParams.get('id'));
//         if (!detailResponse.success) {
//           message.info(detailResponse.message, 3000);
//           return; // Exit early if DetailInvoice fails
//         }
//         const detailData = detailResponse.data;
//         console.log("detailData.data",detailData)
//         // Update State
//         setData({ invoiceData: detailData, HeadData: headData });
//       } catch (error) {
//         console.error('Error fetching data:', error);
//         message.error('An unexpected error occurred', 3000);
//       }
//     };

//     fetchData();
//   }, []);

//   const invoiceColumn = [
//       {
//         title: "شرح کالا",
//         dataIndex: "namekala",
//         key: "namekala",
//       },
//       {
//         title: "تعداد",
//         dataIndex: "qty",
//         key: "qty",
//       },
//       {
//         title: "فی",
//         dataIndex: "fee",
//         key: "fee",
//         render: (text, record) => <span>{formatPrice(record.fee.toString())}</span>,
//       },
//       {
//         title: "تخفیف",
//         dataIndex: "off",
//         key: "off",
//         render: (text, record) => <span>{formatPrice(record.off.toString())}</span>,
//       },
//       {
//         title: "قیمت",
//         dataIndex: "price",
//         key: "price",
//         render: (text, record) => (
//           <span>{formatPrice(((record.count * record.fee)-record.off).toString())}</span>
//         ),
//       },
//     ]

//   const handleGeneratePdf = () => {
//     generateReceipt(data.invoiceData, data.HeadData.customerName, 5000);
//   };

//   const date = "24/6/1403"; // Replace with dynamic date logic if needed
//   const invoiceSerial = gdata.factor;
//   const customerName = "مشتری محترم";
//   const total = 453132153;
//   const discount = 453132153;
//   const finalAmount = 453132153;
//   const contactNumber = "327125123";

//   return (
//     <Page styleName={Classes.page}>
//       <div className={Classes.boddy}>
      
//         <span>
//           <b>شماره فاکتور:</b> <small>{invoiceSerial}</small>
//         </span>
//         <span>
//           <b>تاریخ:</b> <small>{data.HeadData.date}</small>
//         </span>
//         <span>
//           <b>مشتری:</b> <small>{data.HeadData.customerName}</small>
//         </span>

//         <FilteredTable data={data.invoiceData} headers={invoiceColumn}/>
//         <BorderBox className={Classes.priceBox}>
//           <span>
//             <b>جمع فاکتور:</b> {formatPrice(data.HeadData.fee)}
//           </span>
//           <span>
//             <b>جمع تخفیف:</b> {formatPrice(data.HeadData.off)}
//           </span>
//           <span>
//             <b>مبلغ نهایی:</b> {formatPrice(data.HeadData.price)}
//           </span>
//         </BorderBox>
//         <Button
//           type="primary"
//           style={{ width: "100%", margin:0, marginBottom: 15, borderRadius: "25px" }}
//           onClick={handleGeneratePdf}
//         >
//           خروجی pdf
//         </Button>

//         <span>
//           <b>توجه:</b> <small>در صورت وجود هر گونه مغایرت با شماره :</small>{" "}
//           <b>
//             <a
//               href={`tel:${contactNumber}`}
//               style={{ color: "inherit", textDecoration: "none" }}
//             >
//               {contactNumber}
//             </a>
//           </b>{" "}
//           <small>تماس حاصل نمایید</small>
//         </span>
//       </div>
//     </Page>
//   );
// }


import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Button, message, Spin } from "antd";
import Page from "../../components/Page/Page";
import FilteredTable from "../../components/table/filteredTable";
import BorderBox from "../../components/BorderBox";
import generateReceipt from "../../util/pdfExport/pdfRecipt";
import formatPrice from "../../util/FormatPrice/FormatPrice";
import { GetDetailInvoice, GetHeadInvoice } from "../../API/reciept";
import Classes from "./index.module.css";

export default function Receipt() {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const [gdata, setgData]= useState(queryParams.get('id')?{serial:queryParams.get('id').slice(0, 6 ),factor: queryParams.get('id').slice(6, queryParams.get('id').length ) }:{})
  const [data, setData] = useState({ invoiceData: [], HeadData: {} });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const id = queryParams.get("id");
        const headResponse = await GetHeadInvoice({shomInvoice:id, serial:gdata.serial});

        if (!headResponse.success) {
          message.error(headResponse.message, 3000);
          setLoading(false);
          return;
        }

        const detailResponse = await GetDetailInvoice(id);

        if (!detailResponse.success) {
          message.error(detailResponse.message, 3000);
          setLoading(false);
          return;
        }

        setData({
          HeadData: headResponse.data[0],
          invoiceData: detailResponse.data,
        });

      } catch (error) {
        console.error("Error fetching data:", error);
        message.error("An unexpected error occurred", 3000);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const invoiceColumn = [
    {
      title: "شرح کالا",
      dataIndex: "namekala",
      key: "namekala",
    },
    {
      title: "تعداد",
      dataIndex: "qty",
      key: "qty",
    },
    {
      title: "فی",
      dataIndex: "fee",
      key: "fee",
      render: (text, record) => <span>{formatPrice(record.fee)}</span>,
    },
    {
      title: "تخفیف",
      dataIndex: "off",
      key: "off",
      render: (text, record) => <span>{formatPrice(record.off)}</span>,
    },
    {
      title: "قیمت",
      dataIndex: "price",
      key: "price",
      render: (text, record) => (
        <span>{formatPrice((record.qty * record.fee - record.off).toString())}</span>
      ),
    },
  ];

  const handleGeneratePdf = () => {
    generateReceipt(data.HeadData,data.invoiceData,gdata.factor);
  };

  const { HeadData } = data;

  return (
    <Page className={Classes.page}>
      <div className={Classes.boddy}>
        {loading ? (
          <Spin size="large" style={{alignItems: "center", textAlign: "center"}} />
        ) : (
          <>
            <span>
              <b>شماره فاکتور:</b> <small>{gdata.factor}</small>
            </span>
            <span>
              <b>تاریخ:</b> <small>{HeadData.date }</small>
            </span>
            <span>
              <b>مشتری:</b> <small>{HeadData.customerName }</small>
            </span>

            <FilteredTable data={data.invoiceData} headers={invoiceColumn} />
            <BorderBox className={Classes.priceBox}>
              <span>
                <b>جمع فاکتور:</b> {formatPrice(HeadData.fee || 0)}
              </span>
              <span>
                <b>جمع تخفیف:</b> {formatPrice(HeadData.off || 0)}
              </span>
              <span>
                <b>ارزش افزوده:</b> {formatPrice(HeadData.tax || 0)}
              </span>
              <span>
                <b>مبلغ نهایی:</b> {formatPrice(HeadData.price || 0)}
              </span>
            </BorderBox>
            <Button
              type="primary"
              style={{
                width: "100%",
                margin: 0,
                marginBottom: 15,
                borderRadius: "25px",
              }}
              onClick={handleGeneratePdf}
            >
              خروجی pdf
            </Button>

            <span>
              <b>توجه:</b> <small>در صورت وجود هر گونه مغایرت با شماره :</small>{" "}
              <b>
                <a
                  href={`tel:${HeadData.contactNumber}`}
                  style={{ color: "inherit", textDecoration: "none" }}
                >
                  {HeadData.tell || ""}
                </a>
              </b>{" "}
              <small>تماس حاصل نمایید</small>
            </span>
          </>
        )}
      </div>
    </Page>
  );
}
